export default __webpack_public_path__ + "static/media/key.f6b8317e.png";